import { motion } from 'framer-motion'
import styled from 'styled-components'

const SidebarAside = styled(motion.aside)<{ backgroundColor: string }>`
  position: sticky;
  top: 0;
  right: 0;
  height: 100vh;
  background: ${({ backgroundColor }) => backgroundColor};
  overflow: hidden;
  border-radius: ${({ theme }) => theme.UI.BorderRadius.Large}px 0 0
    ${({ theme }) => theme.UI.BorderRadius.Large}px;

  z-index: 1000;
`
const SidebarContainer = styled.div`
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1000;
`

const SidebarContent = styled(motion.div)<{ width?: number }>`
  height: 100%;
  min-width: ${({ width = 350 }) => width}px;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
`

const SidebarCloseButton = styled.div`
  position: absolute;
  cursor: pointer;
  z-index: 11;
  ${({ theme }) => `
    padding: ${theme.UI.SpacingPx.Space3};
    top: ${theme.UI.SpacingPx.Space5};
    right: ${theme.UI.SpacingPx.Space5};
  `};
`

const SidebarBackdrop = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: ${({ theme }) => theme.Components.Modal.Backdrop};
  z-index: 900;
`

export { SidebarAside, SidebarBackdrop, SidebarCloseButton, SidebarContainer, SidebarContent }
